import styled from "styled-components";
import { themevals as theme, themevals } from "theme/themevals";

export const NavWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
`;

export const NavItem = styled.div<{ active?: boolean }>`
  border-radius: 8px;
  font-family: Rubik;
  display: flex;
  flex: 1;
  height:50px;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(active) => (active.active ? "#000" : theme.colors.dkgrey)};
  background-color: ${(active) => (active.active ? "#000" : "#fff")};
  color: ${(active) => (active.active ? "#fff" : theme.colors.dkgrey)};
`;
